import { create } from 'zustand';

interface BreadcrumbStore {
  labels: Record<string, string>;
  setLabel: (path: string, label: string) => void;
  clearLabel: (path: string) => void;
  clearAll: () => void;
}

export const useBreadcrumbStore = create<BreadcrumbStore>((set) => ({
  clearAll: () => set({ labels: {} }),
  clearLabel: (path) =>
    set((state) => ({
      labels: Object.fromEntries(
        Object.entries(state.labels).filter(([key]) => key !== path),
      ),
    })),
  labels: {},
  setLabel: (path, label) =>
    set((state) => ({
      labels: { ...state.labels, [path]: label },
    })),
}));
